<template>
  <svg
    fill="none"
    height="1em"
    viewBox="0 0 20 21"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 16.5L13 10.5L7 4.5"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.4"
    />
  </svg>
</template>
